<template>
  <div>
    <b-modal id="memberNotesModal" modal-class="client-details-modal" centered size="lg" hide-footer
      no-close-on-backdrop hide-header-close @hidden="onClose" :v-model="showNotesModal">
      <!-- Modal Header -->
      <template #modal-header>
        <div class="view-clients-header">
          <b-button variant="close-btn" class="btn-container" @click="$bvModal.hide('memberNotesModal')">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>

      <b-container fluid>
        <div class="form-part">
          <div class="title-text text-center mb-3">
            <h5><strong>Notes</strong></h5>
          </div>
          <div v-if="loading" class="text-center py-4">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-else-if="error" class="alert alert-danger" role="alert">
            {{ error }}
          </div>
          <div v-else>
            <table class="table">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Note</th>
                  <th>File</th>
                  <th>Added By</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!notes.length">
                  <td colspan="5" class="text-center">No notes found</td>
                </tr>
                <tr v-for="(item, index) in notes" :key="index">
                  <td>{{ item.status_text }}</td>
                  <td>{{ item.annote }}</td>
                  <td>
                    <a v-if="item.file" :href="item.file" target="_blank">View File</a>
                    <span v-else>-</span>
                  </td>
                  <td>{{ item.added_by }}</td>
                  <td>{{ item.created_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MemberNotesModal",
  data() {
    return {
      notes: [],
      loading: false,
      error: null
    };
  },
  props: {
    member: {
      type: Object,
      required: true
    },
    showNotesModal: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    async getNotes() {
      if (!this.member?.policy_id) return;

      this.loading = true;
      this.error = null;
      try {
        const { data: { data } } = await axios.get(
          `v2/get-all-notes/${this.member.policy_id}`, {
        }
        );
        this.notes = data;
      } catch (error) {
        console.error("Error fetching notes:", error);
        this.error = "Failed to fetch notes. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    onClose() {
      this.$emit('onCloseModal');
    }
  },
  watch: {
    showNotesModal(value) {
      if (value) {
        this.getNotes();
      }
    }
  }
};
</script>

<style scoped>
.client-details-modal {
  max-width: 80%;
}

.view-clients-header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.btn-container {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
}
</style>
